module.exports = __webpack_public_path__ + "img/t2-6.f7dd61b7.svg";